import React from 'react';
import { CircularProgress, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import type { Kunde } from '@forvalter/types/ForvalterCommonDAL';
import { useGetKunderQuery } from '@klp/reportMapping/api/rtkApi';

interface KundeSelectProps {
    selectedKunde: Kunde | null;
    onChange: (value: Kunde | null) => void;
    required?: boolean;
}

export const KundeSelect: React.FC<KundeSelectProps> = ({
    selectedKunde,
    onChange,
    required = false,
}) => {
    const { t } = useTranslation();
    const { data: kundeList = [], isLoading: kunderLoading } =
        useGetKunderQuery({ navnOrNummer: '' });

    return (
        <Autocomplete<Kunde>
            options={kundeList}
            value={selectedKunde}
            loading={kunderLoading}
            getOptionLabel={(option) => `${option.navn} (${option.nummer})`}
            getOptionSelected={(option, selectedValue) =>
                option.nummer === selectedValue?.nummer
            }
            onChange={(_event, newValue) => {
                onChange(newValue ?? null);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={t('reportMapping.mappingAdd.selectCustomer')}
                    placeholder={t('reportMapping.mappingAdd.searchCustomers')}
                    variant="outlined"
                    fullWidth={true}
                    required={required}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {kunderLoading ? (
                                    <CircularProgress color="inherit" />
                                ) : (
                                    params.InputProps.endAdornment
                                )}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
};
